/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .remax-select label{margin-bottom:0}@media (max-width:599px){hr[_ngcontent-%COMP%]{margin:20px 0}app-input[_ngcontent-%COMP%]     input{width:80%}app-input[_ngcontent-%COMP%]     .input-wrapper{display:flex;align-items:center;justify-content:space-between}}@media all and (max-width:599px) and (-ms-high-contrast:none),(max-width:599px) and (-ms-high-contrast:active){.form[_ngcontent-%COMP%]{background-color:#edeff0;padding:10px}}"];
export { styles as styles };
